// Centralized menu data: dishes, categories, images, and pricing
// DoorDash image CDN base
const DD_IMG = 'https://img.cdn4dd.com/cdn-cgi/image/fit=contain,width=1200,height=672,format=auto/https://doordash-static.s3.amazonaws.com/media/photosV2';

// Shared image URLs referenced across components
export const menuImages = {
  mixGrill: `${DD_IMG}/e848a58e-c05f-4116-b34d-aca3338c9f06-retina-large.jpg`,
  chickenKebab: `${DD_IMG}/f8acbb56-ec81-4d38-8f5b-60bd4c1eb9d0-retina-large.jpg`,
  iraqiBeefShawarma: `${DD_IMG}/cd4a3f7a-4ed7-4743-9c60-d8302b6f5746-retina-large.jpg`,
  qouziLamb: `${DD_IMG}/ea3e388f-b595-4674-87b6-9adeeab8b0bb-retina-large.jpg`,
  chickenShawarmaSaj: `${DD_IMG}/7b56ba2d-d93a-4387-814e-e93b011c43de-retina-large.jpg`,
  falafelMix: `${DD_IMG}/6c3ce9dc-b08a-49a8-82af-b61af8fc524f-retina-large.jpg`,
  hummus: `${DD_IMG}/7f0723bf-93ad-44b6-8951-f2ee9f46b6e0-retina-large.jpg`,
  fattoush: `${DD_IMG}/a79e2033-6f0e-4cd8-bf7e-e9fffc4c6e9d-retina-large.jpg`,
  grilledChicken: `${DD_IMG}/8ab74b39-501c-4f29-865c-78e01a2880c2-retina-large.jpg`,
};

// Signature dishes — bilingual, with shared images
export const signatureDishes = {
  en: [
    { id: 'mix-grill', name: 'Mix Grill Plate', description: '4 skewers of premium grilled meats with vegetables', image: menuImages.mixGrill },
    { id: 'chicken-kebab', name: 'Chicken Kebab Plate', description: 'Includes 3 skewers, grilled tomatoes/onions + side', image: menuImages.chickenKebab },
    { id: 'iraqi-shawarma', name: 'Iraqi Beef Shawarma', description: 'Tender beef shawarma served with samoon bread', image: menuImages.iraqiBeefShawarma },
    { id: 'qouzi-lamb', name: 'Qouzi Lamb Over Rice', description: 'Tender lamb shank served over seasoned rice with fresh vegetables', image: menuImages.qouziLamb },
    { id: 'chicken-shawarma-saj', name: 'Chicken Shawarma Saj', description: 'Juicy chicken shawarma wrapped in saj bread with crispy fries', image: menuImages.chickenShawarmaSaj },
    { id: 'falafel-mix', name: 'Falafel Mix Plate', description: 'Crispy falafel, seasoned fries, roasted eggplant, fresh lettuce', image: menuImages.falafelMix },
  ],
  ar: [
    { id: 'mix-grill', name: 'طبق مشاوي مشكل', description: '4 أسياخ من اللحوم المشوية الفاخرة مع الخضار', image: menuImages.mixGrill },
    { id: 'chicken-kebab', name: 'طبق كباب دجاج', description: 'يشمل 3 أسياخ، طماطم وبصل مشوي + طبق جانبي', image: menuImages.chickenKebab },
    { id: 'iraqi-shawarma', name: 'شاورما لحم عراقية', description: 'شاورما لحم طرية تقدم مع خبز الصمون', image: menuImages.iraqiBeefShawarma },
    { id: 'qouzi-lamb', name: 'قوزي ضأن على الرز', description: 'لحم ضأن طري يقدم على أرز متبل مع خضار طازجة', image: menuImages.qouziLamb },
    { id: 'chicken-shawarma-saj', name: 'شاورما دجاج ساج', description: 'شاورما دجاج طازجة ملفوفة بخبز الصاج مع بطاطس مقرمشة', image: menuImages.chickenShawarmaSaj },
    { id: 'falafel-mix', name: 'طبق فلافل مشكل', description: 'فلافل مقرمشة، بطاطس متبلة، باذنجان مشوي، خس طازج', image: menuImages.falafelMix },
  ]
};

// Menu category images (used in MenuPreview)
export const categoryImages = [
  menuImages.mixGrill,
  menuImages.hummus,
  menuImages.fattoush,
  'https://images.unsplash.com/photo-1544145945-f90425340c7e?w=400&auto=format&fit=crop&q=60'
];

// External links
export const DOORDASH_URL = 'https://www.doordash.com/store/40092379';
export const UBEREATS_URL = 'https://www.ubereats.com/store/salam-grill-329-n-greenville-ave/IzmCVc6xTkydUF2Bk5ji7w?diningMode=PICKUP&surfaceName=';
export const PHONE_NUMBER = '+19722389200';
export const PHONE_DISPLAY = '+1 972-238-9200';
export const EMAIL = 'info@salamgrill.com';

// Category images for full menu
export const categoryBannerImages = {
  'family-platters': '/photos/IMG_family_platters.jpg',
  'appetizers': '/photos/IMG_appetizers.jpg',
  'sandwiches': '/photos/IMG_sandwiches.jpg',
  'charcoal-dishes': '/photos/IMG_charcoal_dishes.jpg',
  'shawarma': '/photos/IMG_shawarma_plate.jpg',
  'iraqi-kitchen': '/photos/IMG_iraqi_kitchen.jpg',
  'drinks': 'https://images.unsplash.com/photo-1583577612013-4fecf7bf8f13?w=800&auto=format&fit=crop&q=60',
  'desserts': 'https://images.unsplash.com/photo-1761828122856-8703baac8e86?w=800&auto=format&fit=crop&q=60',
};

// Full menu (no prices, no duplicates with signatureDishes)
export const fullMenu = [
  {
    id: 'family-platters',
    category: 'Family Platters',
    icon: 'Users',
    items: [
      { name: 'Family Platter for 2', desc: 'Beef Kebab, Lamb Tikka, Shish Tawook, Chicken Kebab, Beef Shawarma, Rice or Fries + 2 Appetizers' },
      { name: 'Family Platter for 4', desc: 'Beef Kebab, Lamb Tikka, Shish Tawook, Chicken Kebab, Beef Shawarma, Rice or Fries + 4 Appetizers' },
      { name: 'Family Platter for 6', desc: 'Beef Kebab, Lamb Tikka, Shish Tawook, Chicken Kebab, Half Grilled Chicken, Beef Shawarma, Rice or Fries + 6 Appetizers' },
    ]
  },
  {
    id: 'appetizers',
    category: 'Appetizers',
    icon: 'Salad',
    items: [
      { name: 'Hummus' }, { name: 'Eggplant Salad' }, { name: 'Baba Ghanoush' },
      { name: 'Green Salad' }, { name: 'Fattoush' }, { name: 'Taboula' },
      { name: 'Garlic Sauce' }, { name: 'Falafel' }, { name: 'Kebbah' },
      { name: 'Cheese Sambosa' }, { name: 'Cucumber Yogurt' }, { name: 'Hot Potatoes' },
      { name: 'Mix Appetizer', desc: 'Choose any 4' },
    ]
  },
  {
    id: 'sandwiches',
    category: 'Sandwiches',
    icon: 'Sandwich',
    note: 'Choice of sauces: Tahini, Garlic, Amba, Iraqi Sauce. Toppings: Tomatoes, Pickles, Lettuce, Onions',
    items: [
      { name: 'Beef Kebab' }, { name: 'Chicken Kebab' }, { name: 'Lamb Tikka' },
      { name: 'Chicken Tawook' }, { name: 'Lamb Liver' }, { name: 'Falafel' },
      { name: 'Falafel Mix' }, { name: 'Beef Burger' }, { name: 'Beef Shawarma' },
      { name: 'Chicken Shawarma' }, { name: 'Saj Beef Shawarma' }, { name: 'Saj Chicken Shawarma' },
    ]
  },
  {
    id: 'charcoal-dishes',
    category: 'Charcoal Signature Dishes',
    icon: 'Flame',
    note: 'Each plate includes 3 skewers, rice, grilled tomatoes & onions',
    items: [
      { name: 'Lamb Tikka Plate' }, { name: 'Iraqi Kebab Plate' },
      { name: 'Spicy Kebab Plate' }, { name: 'Shish Tawook Plate' },
      { name: 'Lamb Liver Plate' }, { name: 'Grilled Fish Msaqouf' },
      { name: 'Shrimp Kebab Plate' }, { name: 'Indian Kebab' },
      { name: 'Arayes' }, { name: 'Wings', desc: '10 pieces' },
      { name: 'Falafel Plate', desc: '6 pieces' },
      { name: 'Grilled Chicken with Rice & Stew', desc: 'Whole or half' },
    ]
  },
  {
    id: 'shawarma',
    category: 'Shawarma Plates',
    icon: 'UtensilsCrossed',
    items: [
      { name: 'Beef Shawarma Plate' }, { name: 'Chicken Shawarma Plate' },
      { name: 'Beef Shawarma Saj Plate' }, { name: 'Chicken Shawarma Saj Plate' },
    ]
  },
  {
    id: 'iraqi-kitchen',
    category: 'From the Iraqi Kitchen',
    icon: 'ChefHat',
    note: 'Upon availability',
    items: [
      { name: 'Tashreeb Lamb' }, { name: 'Tashreeb Shawarma' },
      { name: 'Baja' }, { name: 'Dolma' }, { name: 'Maqlema' },
      { name: 'Bagela' }, { name: 'Gelfrai' }, { name: 'Kahi & Qaymar' },
    ]
  },
  {
    id: 'drinks',
    category: 'Fresh Juices & Drinks',
    icon: 'GlassWater',
    items: [
      { name: 'Lemon Mint' }, { name: 'Orange' }, { name: 'Carrot' },
      { name: 'Mango' }, { name: 'Apple' }, { name: 'Mix Fruit' },
      { name: 'Pineapple' }, { name: 'Strawberry' },
      { name: 'Yogurt Ayran' }, { name: 'Sparkling Water' },
    ]
  },
  {
    id: 'desserts',
    category: 'Desserts',
    icon: 'Cake',
    items: [
      { name: 'Baklava' }, { name: "Lady's Fingers" }, { name: 'Awama' },
    ]
  },
];
